import { Theme } from '@mui/material';

import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(0, 1, 1, 0),

    },
    grid: {
      marginTop: theme.spacing(32),
    },
  }),
);
